import { Alert, Badge, Button, Card, Col, Row, Select, Space, Table, Tag, Tooltip, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { cachedBcpEventService } from '../../services/CachedBcpEventService';
import { columns as pairingsColumns } from '../../utils/pairings-table';
import { columns as playerColumns } from '../../utils/players-table';
import { columns } from '../../utils/teams-table';
import { missionData } from '../../utils/mission-data';
import PlayerModal from '../../components/PlayerModal';

function ListTeams() {
  const [isLoading, setIsLoading] = useState(false);
  const [teams, setTeams] = useState();
  const [pairings, setPairings] = useState();
  const [teamPairings, setTeamPairings] = useState();
  const [error, setError] = useState();

  const [selectedTeam, setSelectedTeam] = useState(undefined);
  const [round, setRound] = useState(1);
  const [teamsMetadata, setTeamsMetadata] = useState(null);
  const [pairingsMetadata, setPairingsMetadata] = useState(null);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [playerModalVisible, setPlayerModalVisible] = useState(false);
  const [playerGameHistory, setPlayerGameHistory] = useState([]);
  // console.log(selectedTeam);
  
  const handlePlayerClick = (player) => {
    if (!pairings || !player || !teams) return;
    
    const gameHistory = [];
    
    pairings.forEach((roundPairings, roundIndex) => {
      const round = roundIndex + 1;
      
      const playerGame = roundPairings.find(pairing => 
        pairing.player1Id === player.id || pairing.player2Id === player.id
      );
      
      if (playerGame) {
        const isPlayer1 = playerGame.player1Id === player.id;
        const playerData = isPlayer1 ? playerGame.player1 : playerGame.player2;
        const opponentData = isPlayer1 ? playerGame.player2 : playerGame.player1;
        const playerGameData = isPlayer1 ? playerGame.player1Game : playerGame.player2Game;
        const opponentGameData = isPlayer1 ? playerGame.player2Game : playerGame.player1Game;
        
        // Find opponent's team
        const opponentTeam = teams.find(team => 
          team.players.some(p => p.id === opponentData.id)
        );
        
        // Get mission data for this round
        const mission = missionData[round];
        const missionText = mission ? 
          `${mission.primaryMission}, ${mission.deploymentType}` : 
          '';
        
        gameHistory.push({
          round,
          playerId: player.id,
          playerName: `${playerData.firstName} ${playerData.lastName}`,
          playerArmy: playerData.armyName,
          playerArmyListId: playerData.armyListObjectId,
          opponentName: `${opponentData.firstName} ${opponentData.lastName}`,
          opponentArmy: opponentData.armyName,
          opponentArmyListId: opponentData.armyListObjectId,
          opponentTeam: opponentTeam?.name || '-',
          playerScore: playerGameData?.gamePoints,
          opponentScore: opponentGameData?.gamePoints,
          mission: missionText,
        });
      }
    });
    
    setSelectedPlayer(player);
    setPlayerGameHistory(gameHistory);
    setPlayerModalVisible(true);
  };

  const retrieveData = async (forceRefresh = false) => {
    setIsLoading(true);
    setError(undefined);

    try {
      const teams = await cachedBcpEventService.getTeams(forceRefresh);
      teams.sort((a, b) => { 
        console.log(a);
        return a.placing - b.placing
      });
      setTeams(teams);
      const metadata = cachedBcpEventService.getCacheMetadata('teams');
      setTeamsMetadata(metadata);
      setIsLoading(false);
    } catch (error) {
      setError(error);
      console.error(error);
      setIsLoading(false);
    }
  };
  const retrievePairings = async (forceRefresh = false) => {
    setIsLoading(true);
    setError(undefined);

    try {
      const pairings = await cachedBcpEventService.getPairings(forceRefresh);

      setPairings(pairings);
      const metadata = cachedBcpEventService.getCacheMetadata('pairings');
      setPairingsMetadata(metadata);

      const teamPairings = await cachedBcpEventService.getTeamPairings(round, forceRefresh);
      // console.log(teamPairings);
      setTeamPairings(teamPairings.data);

      setIsLoading(false);
    } catch (error) {
      setError(error);
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const teamPairings = await cachedBcpEventService.getTeamPairings(round, true);
      // console.log(teamPairings);
      setTeamPairings(teamPairings.data);
    }
    fetchData();
  }, [round]);

  // Load cached data on component mount
  useEffect(() => {
    retrieveData(false);
    retrievePairings(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Row>
        <Col span={18}>
          <Row gutter={8}>
            <Col span={8}>
              <Space>
                <Button
                  name={'Get Teams'}
                  loading={isLoading}
                  onClick={() => {
                    retrieveData(true);
                  }}
                >
                  {!teams ? 'Get Teams' : 'Refresh Teams'}
                </Button>
                <Button
                  name={'Update Pairings'}
                  loading={isLoading}
                  disabled={!teams}
                  onClick={() => {
                    retrievePairings(true);
                  }}
                >
                  {!pairings ? 'Get Pairings' : 'Refresh Pairings'}
                </Button>
              </Space>
            </Col>
            <Col span={16} style={{ display: 'flex', alignItems: 'center' }}>
              <Space>
                {teamsMetadata && teamsMetadata.hasData && (
                  <Tag color="blue">Teams: {teamsMetadata.formattedTime}</Tag>
                )}
                {pairingsMetadata && pairingsMetadata.hasData && (
                  <Tag color="green">Pairings: {pairingsMetadata.formattedTime}</Tag>
                )}
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
      {error && <Alert message={`${error.message}`} type='error' showIcon style={{ marginTop: 16 }} />}
      <Row style={{ paddingTop: '16px' }} gutter={16}>
        <Col span={10}>
          <Card
            title={
              <Space>
                Teams
                <Badge count={teams?.length || 0} overflowCount={999} style={{ backgroundColor: '#1677ff' }} />
              </Space>
            }
            bodyStyle={{ padding: 0 }}
            type={'inner'}
          >
            <Table
              columns={[...columns]}
              dataSource={teams}
              loading={isLoading}
              rowClassName={(record, _index) => {
                return record.name === 'Netherlands' ? 'own-team-row' : '';
              }}
              rowKey={'id'}
              size='small'
              onRow={(team) => ({
                onClick: () => {
                  setSelectedTeam(team);
                },
              })}
              rowSelection={{
                type: 'radio',
                selectedRowKeys: [selectedTeam?.id],
                onSelect: (team) => {
                  setSelectedTeam(team);
                },
              }}
              pagination={{ defaultPageSize: '50', pageSizeOptions: ['25', '50', '100', '200'] }}
            ></Table>
          </Card>
        </Col>
        {selectedTeam && (
          <Col span={14}>
            <Card
              title={
                <Space>
                  Players
                  <Badge
                    count={selectedTeam.players?.length || 0}
                    overflowCount={999}
                    style={{ backgroundColor: '#1677ff' }}
                  />
                </Space>
              }
              bodyStyle={{ padding: 0 }}
              type={'inner'}
            >
              <Table
                columns={[...playerColumns(handlePlayerClick)]}
                dataSource={selectedTeam.players.toSorted((a, b) => a?.user?.firstName.localeCompare(b?.user?.firstName))}
                loading={isLoading}
                rowKey={'playerId'}
                size='small'
                pagination={{ defaultPageSize: '50', pageSizeOptions: ['25', '50', '100', '200'] }}
              ></Table>
            </Card>
            {pairings?.length > 0 && (
              <Card
                title={
                  <>
                    {selectedTeam.name} vs{'  '}
                    <Tooltip title={`Switch to ${
                      teamPairings
                        ?.filter((pairing) => {
                          return (
                            pairing.teamPlayer1Id === selectedTeam.id ||
                            pairing.teamPlayer2Id === selectedTeam.id
                          );
                        })
                        ?.map((pairing) => {
                          return pairing.teamPlayer1Id === selectedTeam.id
                            ? pairing.teamPlayer2
                            : pairing.teamPlayer1;
                        })[0]?.name
                    }`}>
                      <Typography.Link
                        onClick={() => {
                          setSelectedTeam(
                            teams.find(
                              (team) =>
                                team.name ===
                                teamPairings
                                  ?.filter((pairing) => {
                                    return (
                                      pairing.teamPlayer1Id === selectedTeam.id ||
                                      pairing.teamPlayer2Id === selectedTeam.id
                                    );
                                  })
                                  ?.map((pairing) => {
                                    return pairing.teamPlayer1Id === selectedTeam.id
                                      ? pairing.teamPlayer2
                                      : pairing.teamPlayer1;
                                  })[0]?.name
                            )
                          );
                        }}
                      >
                        {
                          teamPairings
                            ?.filter((pairing) => {
                              // console.log(pairing);
                              return (
                                pairing.teamPlayer1Id === selectedTeam.id || pairing.teamPlayer2Id === selectedTeam.id
                              );
                            })
                            ?.map((pairing) => {
                              // console.log(pairing);
                              return pairing.teamPlayer1Id === selectedTeam.id
                                ? pairing.teamPlayer2
                                : pairing.teamPlayer1;
                            })[0]?.name
                        }
                      </Typography.Link>
                    </Tooltip>
                  </>
                }
                bodyStyle={{ padding: 0 }}
                type={'inner'}
                extra={[
                  <Select placeholder='Round' defaultValue={'1'} onSelect={(value) => setRound(value)}>
                    <Select.Option key={'1'} value='1'>
                      Round 1
                    </Select.Option>
                    <Select.Option key={'2'} value='2'>
                      Round 2
                    </Select.Option>
                    <Select.Option key={'3'} value='3'>
                      Round 3
                    </Select.Option>
                    <Select.Option key={'4'} value='4'>
                      Round 4
                    </Select.Option>
                    <Select.Option key={'5'} value='5'>
                      Round 5
                    </Select.Option>
                    <Select.Option key={'6'} value='6'>
                      Round 6
                    </Select.Option>
                    <Select.Option key={'7'} value='7'>
                      Round 7
                    </Select.Option>
                  </Select>,
                ]}
              >
                {missionData[round] && (
                  <div style={{ padding: '16px', backgroundColor: '#f0f2f5', borderBottom: '1px solid #d9d9d9' }}>
                    <Row gutter={16} align="middle">
                      <Col span={6}>
                        <Typography.Text>{missionData[round].mission}</Typography.Text>
                      </Col>
                      <Col span={6}>
                        <Tooltip
                          title={
                            <div style={{ textAlign: 'center', padding: '12px' }}>
                              <img 
                                src={missionData[round].missionSvgUrl} 
                                alt={`${missionData[round].primaryMission} diagram`}
                                style={{ maxWidth: '500px', maxHeight: '500px', width: 'auto', height: 'auto' }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                              <div style={{ marginTop: '12px', color: '#fff', fontSize: '16px', fontWeight: 'bold' }}>
                                {missionData[round].primaryMission}
                              </div>
                            </div>
                          }
                          placement="top"
                          overlayStyle={{ maxWidth: '550px' }}
                        >
                          <Typography.Link 
                            href={missionData[round].primaryMissionUrl} 
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {missionData[round].primaryMission}
                          </Typography.Link>
                        </Tooltip>
                      </Col>
                      <Col span={6}>
                        <Tooltip
                          title={
                            <div style={{ textAlign: 'center', padding: '12px' }}>
                              <img 
                                src={missionData[round].deploymentSvgUrl} 
                                alt={`${missionData[round].deploymentType} diagram`}
                                style={{ maxWidth: '500px', maxHeight: '500px', width: 'auto', height: 'auto' }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                              <div style={{ marginTop: '12px', color: '#fff', fontSize: '16px', fontWeight: 'bold' }}>
                                {missionData[round].deploymentType}
                              </div>
                            </div>
                          }
                          placement="top"
                          overlayStyle={{ maxWidth: '550px' }}
                        >
                          <Typography.Link 
                            href={missionData[round].deploymentUrl} 
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {missionData[round].deploymentType}
                          </Typography.Link>
                        </Tooltip>
                      </Col>
                      <Col span={6} style={{ textAlign: 'right' }}>
                        <Tag color={missionData[round].stage === 'GROUP STAGE' ? 'blue' : 'orange'}>
                          {missionData[round].stage}
                        </Tag>
                      </Col>
                    </Row>
                  </div>
                )}
                <Table
                  columns={pairingsColumns(handlePlayerClick)}
                  dataSource={pairings[round - 1]
                    .filter((pairing) => {
                      const teamPlayers = selectedTeam.players.map((player) => player.id);
                      return teamPlayers.includes(pairing.player1Id) || teamPlayers.includes(pairing.player2Id);
                    })
                    .map((pairing) => {
                      const teamPlayers = selectedTeam.players.map((player) => player.id);

                      if (teamPlayers.includes(pairing.player1Id)) {
                        return pairing;
                      } else {
                        const player1 = pairing.player1;
                        pairing.player1 = pairing.player2;
                        pairing.player2 = player1;

                        const player1Game = pairing.player1Game;
                        pairing.player1Game = pairing.player2Game;
                        pairing.player2Game = player1Game;

                        const player1Id = pairing.player1Id;
                        pairing.player1Id = pairing.player2Id;
                        pairing.player2Id = player1Id;
                      }
                      console.log(pairing);
                      return pairing;
                    })
                    .toSorted((a, b) => a.table - b.table)}
                  loading={isLoading}
                  rowKey={'player1Id'}
                  size='small'
                  pagination={false}
                  summary={(pageData) => {
                    let totalTeam1 = 0;
                    let totalTeam2 = 0;

                    pageData.forEach((pairing) => {
                      totalTeam1 += pairing.player1Game?.gamePoints || 0;
                      totalTeam2 += pairing.player2Game?.gamePoints || 0;
                    });

                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell index={0}></Table.Summary.Cell>
                          <Table.Summary.Cell index={0}></Table.Summary.Cell>
                          <Table.Summary.Cell index={0}></Table.Summary.Cell>
                          <Table.Summary.Cell index={1}></Table.Summary.Cell>
                          <Table.Summary.Cell index={1}></Table.Summary.Cell>
                          <Table.Summary.Cell index={2}>
                            <b>
                              {totalTeam1}-{totalTeam2}
                            </b>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                ></Table>
              </Card>
            )}
          </Col>
        )}
      </Row>
      <PlayerModal
        player={selectedPlayer}
        visible={playerModalVisible}
        onClose={() => setPlayerModalVisible(false)}
        playerGameHistory={playerGameHistory}
      />
    </div>
  );
}

export default ListTeams;
